import {
    applyBookingPromocodeThunk,
    clearBookingPromocode,
    clearPromocodeError,
    clearValidatedPromocode,
    removeBookingPromocodeThunk,
    resetPromocodesState,
    validatePromocodeThunk
} from '@spike/promocodes-action';
import { createWrapper } from 'api/ApiClient';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { INVALID_PROMOCODE_MESSAGE } from 'utils/promoCodeUtils';

export const resetOnlineBookingPromocode = resetPromocodesState;
export { clearPromocodeError };

export const applyPendingPromocodeThunk = (): ThunkAction<
    Promise<void>,
    RootState,
    null,
    RootAction
> => {
    return async (dispatch, getState) => {
        const state = getState();
        const bookingId = state.bookings.booking?.id;
        const validated = state.promocodes.validatedPromocode;
        const alreadyApplied = !!state.promocodes.bookingPromocode?.promocode;

        if (!bookingId || !validated || alreadyApplied) {
            return;
        }

        try {
            await dispatch(
                applyBookingPromocodeThunk(createWrapper(state), bookingId, validated.name)
            );
        } catch {
            throw new Error(INVALID_PROMOCODE_MESSAGE);
        }
    };
};

export const submitPromocodeThunk = (
    code: string
): ThunkAction<Promise<void>, RootState, null, RootAction> => {
    return async (dispatch, getState) => {
        const trimmed = code.trim();

        if (!trimmed) {
            return;
        }

        const state = getState();
        const wrapper = createWrapper(state);
        const bookingId = state.bookings.booking?.id;

        try {
            if (bookingId) {
                await dispatch(applyBookingPromocodeThunk(wrapper, bookingId, trimmed));
                return;
            }

            await dispatch(validatePromocodeThunk(wrapper, trimmed));
        } catch {
            if (bookingId) {
                dispatch(clearValidatedPromocode());
            }
            throw new Error(INVALID_PROMOCODE_MESSAGE);
        }
    };
};

export const removeSubmittedPromocodeThunk = (): ThunkAction<
    Promise<void>,
    RootState,
    null,
    RootAction
> => {
    return async (dispatch, getState) => {
        const state = getState();
        const bookingId = state.bookings.booking?.id;

        if (bookingId && state.promocodes.bookingPromocode) {
            await dispatch(removeBookingPromocodeThunk(createWrapper(state), bookingId));
            return;
        }

        dispatch(clearValidatedPromocode());
        dispatch(clearBookingPromocode());
    };
};
